export default __webpack_public_path__ + "static/media/timer.4ef57659.mp3";